import { render, staticRenderFns } from "./KETKanban.vue?vue&type=template&id=01de8e8c&"
import script from "./KETKanban.vue?vue&type=script&lang=js&"
export * from "./KETKanban.vue?vue&type=script&lang=js&"
import style0 from "./KETKanban.vue?vue&type=style&index=0&id=01de8e8c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports